.date-picker-wrapper
  .input-addon
    span.input-addon-item: i.ion-ios-clock-outline
    input(name="date", type="datetime-local", value=formattedDate).input-addon-field
